import { render, staticRenderFns } from "./ProfileButton.vue?vue&type=template&id=6b25603e&scoped=true&"
import script from "./ProfileButton.vue?vue&type=script&lang=js&"
export * from "./ProfileButton.vue?vue&type=script&lang=js&"
import style1 from "./ProfileButton.vue?vue&type=style&index=1&id=6b25603e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b25603e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VDialog,VForm,VTextField,VToolbar})
